export default "__VITE_ASSET__IlXYGvlO__"